import { addMonths } from 'date-fns'

export const getExportMonths = currentMonth =>
  Array.from({ length: 14 }, (_, index) =>
    addMonths(currentMonth, 1 - index).toISOString()
  )
